
import {
  FormControl, InputLabel, Select, MenuItem,
  Box, Button, Card, CardContent, Typography, CardHeader, TextField
} from '@mui/material';
import React from 'react';
import { NotificationProfileDetails } from './NotificationProfileDetails'
import _ from 'lodash'
import CustomAlert from '../../components/CustomAlert';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

let defaultProfile = {
  "name": "",
  "additionalEmailAddresses": [],
  "timeSpans": [],
  "regions": [],
  "extRegions": [],
  "eventTypeImpacts": {},
  "regionlessEventTypes": [],
  "allImpactEventTypes": [],
  "isNew": true
}

const NotificationProfilesListCard = (props) => {
  const setSelectedProfile = props.setSelectedProfile;
  const setOriginalProfile = props.setOriginalProfile;
  const originalProfile = props.originalProfile;
  const profiles = props.profiles;
  const setIsNew = props.setIsNew;
  const setLoading = props.setLoading;
  const deleteProfile = props.deleteProfile;
  const selectedProfile = props.selectedProfile;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  const setProfileFromName = (event) => {
    const name = event.target.value;
    const profile = profiles.find(p => p.name === name);
    setOriginalProfile((_.cloneDeep(profile)));
  }

  React.useEffect(() => {
    setSelectedProfile((_.cloneDeep(originalProfile)));
    setLoading(false);
  }, [originalProfile])

  return (
    <Box>
      <FormControl sx={matches ? { width: "75%" } : { width: "100%" }}>
        <InputLabel id="select-label">Select a Profile</InputLabel>
        <Select
          labelId="select-label"
          id="simple-select"
          label="Select a Profile"
          onChange={setProfileFromName}
          value=""
        >
          {profiles?.map(profile => {
            return <MenuItem value={profile.name} key={profile.name}>{profile.name}</MenuItem>
          })}
        </Select>
      </FormControl>
      <Button color="primary" sx={matches ? { marginLeft: 3, marginTop: 1 } : { marginTop: 1 }} onClick={() => { setIsNew(true) }}
        variant="contained">New</Button>
      <Button color="primary" sx={matches ? { marginLeft: 3, marginTop: 1 } : { marginTop: 1, marginLeft: 1 }} onClick={() => { deleteProfile(selectedProfile) }}
        variant="contained" disabled={null === originalProfile}>Delete</Button>
    </Box>
  )
}

export const NotificationProfilesList = (props) => {
  const [editedProfile, setEditedProfile] = React.useState(false);
  const [selectedProfile, setSelectedProfile] = React.useState(null);
  const [originalProfile, setOriginalProfile] = React.useState(null);
  const [isNew, setIsNew] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const setIsUser = props.setIsUser;
  const setFooterSelection = props.setFooterSelection;
  const user = props.user;
  const profiles = user?.extProfiles;
  const setRefreshUser = props.setRefreshUser;
  const [showAlert, setShowAlert] = React.useState(false);
  const [message, setMessage] = React.useState("")
  const [severity, setSeverity] = React.useState("success");

  React.useEffect(() => {
    if ("" !== message) {
      setShowAlert(true);
    }
  }, [message])

  React.useEffect(() => {
    if (!showAlert) {
      setMessage("");
    }
  }, [showAlert])

  React.useEffect(() => {
    setIsUser(true);
    setFooterSelection(1);
  }, [])

  React.useEffect(() => {
    if (isNew) {
      setSelectedProfile(_.cloneDeep(defaultProfile));
      setOriginalProfile(_.cloneDeep(defaultProfile));
      setIsNew(false);
    }
  }, [isNew, defaultProfile]);


  React.useEffect(() => {
    if (user) {
      setIsNew(user.extProfiles.length === 0)
    }
  }, [])

  React.useEffect(() => {
    if (user) {
      setIsNew(user.extProfiles.length === 0)
    }
  }, [user])

  /*

let defaultProfile = {
  "name": "",
  "additionalEmailAddresses": [],
  "timeSpans": [],
  "regions": [],
  "extRegions": [],
  "eventTypeImpacts": {},
  "regionlessEventTypes": [],
  "allImpactEventTypes": [],
  "isNew": true
}

  */

  React.useEffect(() => {
    if (!loading && selectedProfile) {
      let isEdited = !_.isEqual(selectedProfile, originalProfile);
      let requiredFieldsValid = selectedProfile.name !== "" && selectedProfile.timeSpans.length > 0 && selectedProfile.extRegions.length > 0;
      setEditedProfile(isEdited && requiredFieldsValid);
    }
    else setLoading(false);
  }, [selectedProfile, originalProfile, loading])

  const saveProfile = async (selectedProfile) => {
    console.log("Saving Profile ", selectedProfile);
    delete (selectedProfile.isNew);
    try {
      const response = await fetch(process.env.REACT_APP_API_HOST + "/account/update/profile", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        }, body: JSON.stringify(selectedProfile)
      })
      const ret = await response.json();
      if (ret.success) {
        setMessage("Profile Updated");
        setOriginalProfile(_.cloneDeep(selectedProfile));
        setRefreshUser(true);
      } else {
        setMessage("Profile Update Failed");
        setSeverity("warning");
      }
    } catch (ex) {
      setMessage("Profile Update Failed")
      setSeverity("warning");
    }
    
  }

  const deleteProfile = async (selectedProfile) => {
    try {
      const response = await fetch(process.env.REACT_APP_API_HOST + "/account/delete/profile", {
        method: "PUT",
        headers: {
          'Authorization': 'Basic ' + btoa(process.env.REACT_APP_AUTH),
          "Content-Type": "application/json"
        },
        body: JSON.stringify(selectedProfile)
      })
      const ret = await response.json();
      if (ret.success) {
        setMessage("Profile Deleted");
        setOriginalProfile(null);
        setRefreshUser(true);
      } else {
        setMessage("Profile Delete Failed")
      }
    } catch (ex) {
      setMessage("Profile Delete Failed");
      setSeverity("warning");
    }
  }

  const resetProfile = () => {
    setSelectedProfile(_.cloneDeep(originalProfile));
  }

  if (null != user) return (
    <>
      <CustomAlert showAlert={showAlert} message={message} severity={severity} setShowAlert={setShowAlert} setMessage={setMessage} />
      <Box component="div" sx={{
        height: "calc(100vh - 160px)",
        width: "100%",
        overflow: "auto",
        padding: 2
      }}>
        {profiles && profiles.length > 0 ?
          <Card>
            <CardHeader
              title="Email Notification Profiles"
              subheader="Create notification profiles for email notifications."
            />
            <CardContent>
              <NotificationProfilesListCard setSelectedProfile={setSelectedProfile} selectedProfile={selectedProfile} profiles={profiles}
                setOriginalProfile={setOriginalProfile} setIsNew={setIsNew} originalProfile={originalProfile} setLoading={setLoading} deleteProfile={deleteProfile} />
            </CardContent>
          </Card> : null
        }
        {selectedProfile ? <NotificationProfileDetails selectedProfile={selectedProfile} isNew={isNew} setSelectedProfile={setSelectedProfile} editedProfile={editedProfile} resetProfile={resetProfile} saveUser={saveProfile} loading={loading} /> : null}
      </Box>
    </>
  )

  return null;
};
